module.exports = __webpack_public_path__ + "img/promobox_01.b2030942.svg";